import { PDFViewer } from "@react-pdf/renderer";
import PrintMasterPojo from "./print-master-pojo.component";

const PDFMasterPojoComponent = (props: any) => {
  return (
    <div>
      <PDFViewer width="1000" height="650" className="app" >
        <PrintMasterPojo data={props.data} />
      </PDFViewer>
    </div>
  );
}

export default PDFMasterPojoComponent;